<div id="print">
  <div class="print_content">
    <div class="flex f_align_start gap_10">
      <div class="f_col f_align_c">
        <img src="assets/emblem.png" width="80px" alt="Emblem" />
      </div>
      <div class="f_col f_end mt_10">
        <img [src]="environment.theme.logo" width="50px" alt="Logo" />
      </div>
      <div class="ml_auto">{{today | date: 'fullDate'}}</div>
    </div>
    <h2 class="print_title">{{data.title}}</h2>

    <table class="qr_table">
      <tbody>
        <ng-container *ngFor="let payment of data.dataList; let i = index">
          <tr *ngIf="i % 2 === 0">
            <td class="qr_td">
              <ng-container *ngTemplateOutlet="cardRowTemplate; context: { item: payment }"></ng-container>
            </td>
            <td class="qr_td" *ngIf="data.dataList[i + 1] as next">
              <ng-container *ngTemplateOutlet="cardRowTemplate; context: { item: next }"></ng-container>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <ng-template #cardRowTemplate let-item="item">
      <div class="qr_card_row">
        <div class="qr_qr">
          <qrcode [qrdata]="item?.qrCode" [width]="100" [errorCorrectionLevel]="'M'"></qrcode>
        </div>
        <div class="qr_infos">
          <p *ngIf="item?.state"><b>{{'form.state' | translate}}:</b> {{getStatus(item)}}</p>
          <p *ngIf="item?.metadata?.firstName"><b>{{'form.name' | translate}}:</b>{{item.metadata.firstName}} {{ item.metadata.lastName }}</p>
          <p *ngIf="item?.metadata?.phone"><b>{{'form.phone' | translate}}:</b> {{item.metadata.phone}}</p>
          <p *ngIf="item?.metadata?.idCard"><b>{{'form.idCard' | translate}}:</b> {{item.metadata.idCard}}</p>
          <p *ngIf="item?.amountCents"><b>{{'form.amount' | translate}}:</b>{{ item.amountCents / 100 }} {{item.currency}}</p>
          <p *ngIf="item?.timeslot"><b>{{'form.timeslot' | translate}}:</b>{{ item.timeslot }}</p>
          <p *ngIf="item?.metadata?.buyingOption"><b>{{'form.buyingOption' | translate}}:</b>{{item.metadata.buyingOption?.type || item.metadata.buyingOption}}</p>
          <p *ngIf="item?.created_place_id"><b>{{ 'form.place' | translate }}:</b> {{item.created_place_id}}</p>
          <p *ngIf="item?.createdAt"><b>{{ 'form.created_date' | translate}}:</b> {{item.createdAt}}</p>
          <p *ngIf="item?.id"><b>{{'form.id' | translate}}:</b> {{ item.id }}</p>
          <p *ngIf="item?.metadata?.worker"><b>{{'form.worker' | translate}}:</b> {{item.metadata.worker}}</p>
        </div>
      </div>
    </ng-template>
  </div>
</div>




